<template>
  <div class="flex flex-col flex-wrap">
    <DisplayStatAverageCoaches
      statName="longévité client"
      tooltip="Moyenne de toutes les séances validées par tous les coachs avec tous leurs clients (hors séances découvertes, hors commandes marché, hors B2B)."
      :statAverage="data.averageLongevityRate"
    />

    <div class="flex flex-col">
      <h3>
        TOP COACHS
        <i
          class="fa fa-info-circle ml-05"
          v-tooltip="{
            content: 'Coachs ayant la meilleurs longevité.',
            placement: 'top',
          }"
        ></i>
      </h3>
      <LongevityLevel
        id="successCoachs"
        type="success"
        :coachsProps="successCoachs"
      />
    </div>

    <div class="flex flex-col mt-3">
      <h3>
        MIDDLE COACHS
        <i
          class="fa fa-info-circle ml-05"
          v-tooltip="{
            content: 'Coachs ayant une longevité moyenne.',
            placement: 'top',
          }"
        ></i>
      </h3>
      <LongevityLevel
        id="warningCoachs"
        type="warning"
        :coachsProps="warningCoachs"
      />
    </div>

    <div class="flex flex-col mt-3">
      <h3>
        BAD COACHS
        <i
          class="fa fa-info-circle ml-05"
          v-tooltip="{
            content: 'Coachs ayant une mauvaise longevité.',
            placement: 'top',
          }"
        ></i>
      </h3>
      <LongevityLevel
        id="dangerCoachs"
        type="danger"
        :coachsProps="dangerCoachs"
      />
    </div>
  </div>
</template>

<script>
import DisplayStatAverageCoaches from "@/components/coach-manager/DisplayStatAverageCoaches";
import LongevityLevel from "@/components/coach-manager/longevity/LongevityLevel";

export default {
  components: {
    LongevityLevel,
    DisplayStatAverageCoaches,
  },

  props: {
    data: { type: Object, required: true },
    filters: {
      required: true,
      type: Object,
    },
    currentCoach: null,
  },

  data() {
    return {
      successCoachs: this.data.success,
      warningCoachs: this.data.middle,
      dangerCoachs: this.data.bad,
    };
  },

  methods: {
    goToUser(id) {
      const route = this.$router.resolve({
        name: "user-details",
        params: {
          id,
        },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
